<template>
  <div id="download-progres" class="mc-download">
    <div class="mc-download__header d-flex justify-content-between">
      <div class="d-flex">
        <h4>
          {{
            downloadVideoHistoriesInProgreess.length
              ? $t('videoHistory.widgetDownload.preparingDownload')
              : $t('videoHistory.widgetDownload.downloadFinish')
          }}
        </h4>
        <span
          v-if="downloadVideoHistoriesInProgreess.length"
          class="mx-2 spinner-border spinner-border-sm text-white"
        ></span>
      </div>
      <div>
        <i
          :style="{
            position: downloadVideoHistoriesInProgreess.length ? 'static' : undefined,
          }"
          class="mc-fa icon-fill_arrow-ios-up"
          @click="toggleDownload()"
        ></i>
        <i class="mc-fa icon-outline_close ms-2" @click="closeDownload()"></i>
      </div>
    </div>
    <div class="accordion mc-download__body" role="tablist">
      <div class="mc-download__body-wrapper">
        <div class="mc-download__info" header-tag="header" role="tab">
          <div v-b-toggle.download-1 class="d-flex justify-content-between">
            <p class="blue-500">
              {{ $t('videoHistory.widgetDownload.complete') }} ({{
                downloadVideoHistoriesSuccess.length
              }})
            </p>
            <i class="mc-fa icon-fill_arrow-ios-down"></i>
          </div>
        </div>
        <b-collapse
          id="download-1"
          class="mc-download__list"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <template v-if="downloadVideoHistoriesSuccess.length">
            <div
              v-for="(video, index) in downloadVideoHistoriesSuccess"
              :key="index"
              class="mc-download__list-item"
            >
              <div class="mc-download__list-item-wrapper d-flex">
                <i class="mc-fa icon-fill_videorecord"></i>
                <div class="mc-download__list-item-text">
                  <p
                    :title="`${video.licensePlate} ${video.convertedChannel} - ${momentDMYH(
                      convertUtcToLocalDate(video.startTime, video.deviceTimezone)
                    )} - ${momentDMYH(convertUtcToLocalDate(video.endTime, video.deviceTimezone))}`"
                  >
                    {{ video.licensePlate }} {{ video.convertedChannel }} -
                    {{ momentDMYH(convertUtcToLocalDate(video.startTime, video.deviceTimezone)) }}
                    -
                    {{ momentDMYH(convertUtcToLocalDate(video.endTime, video.deviceTimezone)) }}
                  </p>
                  <p>
                    <span>
                      {{ $t('videoHistory.widgetDownload.downloadTime') }}
                      {{ momentDMYH(video.downloadOn) }}
                    </span>
                  </p>
                </div>
              </div>
              <b-row class="mt-2 mc-download__list-item-button">
                <b-col md="6">
                  <b-button
                    class="w-100"
                    variant="outline-primary"
                    @click="handleClickShowVideo(video)"
                  >
                    <i class="mc-fa icon-outline_play-circle"></i>
                    {{ $t('videoHistory.widgetDownload.watchVideo') }}
                  </b-button>
                </b-col>
                <b-col md="6">
                  <a
                    v-if="isVideoDemo"
                    :href="video.url"
                    download
                    class="btn btn-primary mc-button__download-video-history"
                  >
                    <i class="mc-fa icon-outline_download" />
                    {{ $t('videoHistory.widgetDownload.download') }}
                  </a>
                  <b-button v-else variant="primary" class="w-100" @click="startDownload(video)">
                    <i class="mc-fa icon-outline_download"></i>
                    {{ $t('videoHistory.widgetDownload.download') }}
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </template>
          <template v-else>
            <p class="text-center">
              {{ $t('global.action.noDownloadSuccess') }}
            </p>
          </template>
        </b-collapse>
      </div>
      <div class="mc-download__body-wrapper">
        <div class="mc-download__info" header-tag="header" role="tab">
          <div v-b-toggle.download-2 class="d-flex justify-content-between">
            <p class="blue-500">
              {{ $t('videoHistory.widgetDownload.running') }} ({{
                downloadVideoHistoriesInProgreess.length
              }})
            </p>
            <i class="mc-fa icon-fill_arrow-ios-down"></i>
          </div>
        </div>
        <b-collapse
          id="download-2"
          ref="downloadInProgress"
          class="mc-download__list"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <template v-if="downloadVideoHistoriesInProgreess.length">
            <div
              v-for="(video, index) in downloadVideoHistoriesInProgreess"
              :key="index"
              class="mc-download__list-item"
            >
              <div class="mc-download__list-item-wrapper d-flex">
                <i class="mc-fa icon-fill_videorecord"></i>
                <div class="mc-download__list-item-text">
                  <p
                    :title="`${video.licensePlate} ${video.convertedChannel} - ${momentDMYH(
                      convertUtcToLocalDate(video.startTime, video.deviceTimezone)
                    )} - ${momentDMYH(convertUtcToLocalDate(video.endTime, video.deviceTimezone))}`"
                  >
                    {{ video.licensePlate }} {{ video.convertedChannel }} -
                    {{ momentDMYH(convertUtcToLocalDate(video.startTime, video.deviceTimezone)) }}
                    -
                    {{ momentDMYH(convertUtcToLocalDate(video.endTime, video.deviceTimezone)) }}
                  </p>
                  <p>
                    <span>
                      {{ $t('videoHistory.widgetDownload.downloadTime') }}
                      {{ momentDMYH(video.downloadOn) }}
                    </span>
                  </p>
                </div>
              </div>
              <b-progress :value="100" variant="secondary" :animated="true" class="mt-3" />
            </div>
          </template>
          <template v-else>
            <p class="text-center">
              {{ $t('global.action.noDownloadProcess') }}
            </p>
          </template>
        </b-collapse>
      </div>
      <div class="mc-download__body-wrapper">
        <div header-tag="header" role="tab" class="mc-download__info">
          <div v-b-toggle.download-3 class="d-flex justify-content-between">
            <!--  eslint-disable-next-line vue/singleline-html-element-content-newline -->
            <p class="blue-500">
              {{ $t('videoHistory.widgetDownload.stop') }} ({{
                downlaodVideoHistoriesFailed.length
              }})
            </p>
            <i class="mc-fa icon-fill_arrow-ios-down"></i>
          </div>
        </div>
        <b-collapse
          id="download-3"
          class="mc-download__list mc-download__list--fail"
          role="tabpanel"
          visible
          accordion="my-accordion"
        >
          <template v-if="downlaodVideoHistoriesFailed.length">
            <div
              v-for="(video, index) in downlaodVideoHistoriesFailed"
              :key="index"
              class="mc-download__list-item"
            >
              <div class="mc-download__list-item-wrapper d-flex">
                <i class="mc-fa icon-fill_videorecord"></i>
                <div class="mc-download__list-item-text">
                  <p
                    :title="`${video.licensePlate} ${video.convertedChannel} - ${momentDMYH(
                      convertUtcToLocalDate(video.startTime, video.deviceTimezone)
                    )} - ${momentDMYH(convertUtcToLocalDate(video.endTime, video.deviceTimezone))}`"
                  >
                    {{ video.licensePlate }} {{ video.convertedChannel }} -
                    {{ momentDMYH(convertUtcToLocalDate(video.startTime, video.deviceTimezone)) }}
                    -
                    {{ momentDMYH(convertUtcToLocalDate(video.endTime, video.deviceTimezone)) }}
                  </p>
                  <p>
                    <span class="red-500">
                      <i class="mc-fa icon-fill_alert-triangle" />
                      {{ $t('videoHistory.widgetDownload.failedDownload') }}
                    </span>
                    <span> {{ momentDMYH(video.downloadOn) }}</span>
                  </p>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <p class="text-center">
              {{ $t('global.action.noDownloadStop') }}
            </p>
          </template>
        </b-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { GET_PAYLOAD } from '@/services/api/auth'
moment.locale('id')

export default {
  mixins: [Helper, MixPanel],
  data() {
    return {
      payloadWs: null,
      isWsConnected: false,
      forceDisconnect: false,
      socket: null,
    }
  },
  computed: {
    ...mapGetters({
      getFeatureFlagData: 'identity/getFeatureFlagData',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    ...mapState('vehicle', ['dvhPollingData']),
    loadingDownload() {
      return this.$store.state.vehicle.isLoadingDownloadVideoHistoriesWidget
    },
    downloadVideoHistoriesInProgreess() {
      if (Object.keys(this.dvhPollingData).length === 0) return []
      return Object.keys(this.dvhPollingData)
        .filter((downloadId) => this.dvhPollingData[downloadId].status === 'I')
        .map((downloadId) => this.dvhPollingData[downloadId])
    },
    downlaodVideoHistoriesFailed() {
      if (Object.keys(this.dvhPollingData).length === 0) return []
      return Object.keys(this.dvhPollingData)
        .filter((downloadId) => this.dvhPollingData[downloadId].status === 'F')
        .map((downloadId) => this.dvhPollingData[downloadId])
    },
    downloadVideoHistoriesSuccess() {
      return Object.keys(this.dvhPollingData)
        .filter((downloadId) => this.dvhPollingData[downloadId].status === 'S')
        .map((downloadId) => this.dvhPollingData[downloadId])
    },
    isVideoDemo() {
      const dataDemoVideoHistory = JSON.parse(
        this.getFeatureFlagData('vsms2_trackvision2_playback_demo_id').value
      )
      if (!this.$route.query?.vehicleId) {
        return null
      }
      return (
        process.env.NODE_ENV === 'production' &&
        Object.keys(dataDemoVideoHistory).includes(this.$route.query.vehicleId.toString())
      )
    },
  },

  async mounted() {
    await this.loadPayloadWsDvh()
    await this.startWebSocket()
  },
  beforeDestroy() {
    this.forceDisconnect = true
    if (this.socket) {
      this.socket.close()
    }
  },
  methods: {
    async startWebSocket() {
      if (!this.payloadWs) return
      const obj = {
        type: 'update_tags',
        data: this.payloadWs,
      }
      this.socket = new WebSocket(
        `${process.env.VUE_APP_WS_URL}/ws?token=${localStorage.getItem('wsToken')}`
      )
      this.socket.onopen = () => {
        this.socket.send(JSON.stringify(obj))
        this.isWsConnected = true
      }

      this.socket.onmessage = (dataWs) => {
        const data = JSON.parse(dataWs.data)
        if (data.type?.startsWith('dvh-')) {
          const dataDvh = data.payload
          const isInProgress = this.downloadVideoHistoriesInProgreess.some(
            (dvh) => dvh.downloadId === dataDvh.downloadId
          )
          if ((dataDvh.status === 'S' || dataDvh.status === 'F') && isInProgress) {
            this.$store.commit(
              'vehicle/removeDownloadVideoPerItemStatus',
              dataDvh.vehicleId + ' ' + new Date(dataDvh.startTime).toISOString()
            )
            this.$store.commit('vehicle/updateDvhPollingData', {
              downloadId: dataDvh.downloadId,
              data: dataDvh,
            })
          }
        }
      }

      this.socket.onclose = async () => {
        if (this.forceDisconnect) return
        this.startWebSocket()
      }
    },
    async loadPayloadWsDvh() {
      try {
        const filterByType = ['DownloadVideoHistory']
        const res = await this.$apollo.query({
          query: GET_PAYLOAD,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              filterByType,
            },
          },
        })
        const payload = res.data.getPayload.payload.payload
        this.payloadWs = payload
      } catch (error) {
        console.error(error)
        this.$mcToast.error(this.$t('global.somethingWentWrong'))
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    async fetchDownloadVideoHistories() {
      try {
        const variables = {
          filter: {
            allUsers: false,
            startDate: this.formatDateToUtc(moment(new Date()).format('YYYY-MM-DD 00:00')),
            endDate: this.formatDateToUtc(this.now()),
            orderBy: JSON.stringify({ downloadOn: 'desc' }),
          },
        }
        const data = await this.$store.dispatch('vehicle/requestDownloadVideoHistories', variables)
        return data
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    toggleDownload() {
      var toggleDownload = document.getElementById('download-progres')
      toggleDownload.classList.toggle('show-body')
    },

    closeDownload() {
      document.body.classList.remove('mc-widget-download')
      this.$store.commit('vehicle/setShowWidgetDownload', false)
      this.$store.commit('vehicle/updateLoadingDownloadVideoHistoriesWidget', false)
      this.$store.commit('vehicle/resetDownloadVideoPerItemStatus')
    },

    async startDownload(video) {
      if (this.isVideoDemo) {
        return
      }
      this.track('Click Video History Download', {
        license_plate: this.$store.state.vehicle.vehicleDetail.licensePlate,
        filename: `${video.mediaFilename}`,
      })
      if (video.url) {
        const link = document.createElement('a')
        link.href = video.url
        link.setAttribute('download', `${video.mediaFilename}`)
        link.click()
        link.remove()
      }
    },

    handleClickShowVideo(video) {
      if (this.isVideoDemo) {
        window.sessionStorage.setItem(
          'tv2VideoHistoryDemoData',
          JSON.stringify(this.downloadVideoHistoriesSuccess)
        )
      }
      const isMenuTrackvision = this.hasAccessAll(['b3h-new-trackvision-menu:read'])
      const routeData = this.$router.resolve({
        name: isMenuTrackvision ? 'Video History Trackvision Download' : 'Video History 3 Download',
        query: {
          modalShowDownloadVideoId: video.downloadId,
          videoHistoryVehicleId: video.vehicleId,
          ...(this.isVideoDemo ? { isDemo: true } : {}),
        },
      })
      window.open(routeData.href, '_blank')
    },

    checkVideoitemActiveInRanges(video, downloadPerItemActive) {
      return downloadPerItemActive.some((item) => {
        return (
          this.isBetweenDate(item.startTime, video.startTime, video.endTime) ||
          this.isBetweenDate(item.endTime, video.startTime, video.endTime) ||
          (video.startTime === item.startTime && video.endTime === item.endTime)
        )
      })
    },
  },
}
</script>
